import React, { useEffect } from "react"
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  colors as muiColors,
} from "@mui/material"

import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDownIcon from "@mui/icons-material/ArrowDropDown"
import OpportunityAddIcon from "../../Icons/OpportunityAddIcon"
import RatingIcon from "../../Icons/RatingIcon"
import { colors } from "../../../../styles/commonStyles"

type Props = {}

const OpportunityMetricNameCell = (props: any) => {
  const { row, handleOpportunitySetModalOpen, renderedCellValue } = props

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "0 10px",
      }}
    >
      {row.getCanExpand() ? (
        <IconButton
          sx={{ marginLeft: row.depth == 1 ? "20px" : "0px" }}
          id="basic-button"
          // aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          // aria-expanded={open ? 'true' : undefined}
          onClick={row.getToggleExpandedHandler()}
        >
          {/* <img src={row.getIsExpanded() ? ArrowDown : ArrowDown} alt="" /> */}

          {row.getIsExpanded() ? <ArrowDownIcon /> : <ArrowRightIcon />}
        </IconButton>
      ) : null}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          {/* <Tooltip title={row.depth == 1 ? (row.original.practices_updated_today ? "All practices were updated today" : "All practices were not updated today") : row?.original?.metric_hover_text} placement="right"> */}
          <Tooltip title={row?.original?.metric_hover_text} placement="right">
            <Typography
              sx={{ marginLeft: row.depth == 2 ? "40px" : "0px" }}
              fontWeight={
                row.depth == 1 ? "700" : row.depth == 0 ? "600" : "500"
              }
              // color={row.depth == 0 ? "#3C77EF" : (row.depth == 1 ? (row.original.practices_updated_today ? colors.primaryGreen : colors.primaryRed) : "#000000")}
              color={row.depth == 0 ? "#3C77EF" : colors.primaryBlack}
            >
              {renderedCellValue}
            </Typography>
          </Tooltip>
          {row.depth == 0 ? (
            <Typography fontSize={10} color={"#a1a1a1"}>
              {row?.original?.metric_bucket}
            </Typography>
          ) : null}
        </Box>
        <Box>
          {row?.depth == 2 ? (
            <OpportunityAddIcon row={row} />
          ) : (
            <RatingIcon row={row} />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default OpportunityMetricNameCell
